import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ErrorcontrolService } from 'basecomponents';
import { MessageError } from 'base-models';
import { UploadService } from 'guploadmgr';
import { BaseComponent } from '@solar/shared';




@Component({
  selector: 'app-upload-simple-file',
  templateUrl: './upload-simple-file.component.html',
  styleUrls: ['./upload-simple-file.component.scss']
})
export class UploadSimpleFileComponent extends BaseComponent implements OnInit {
  /**
   * name to identify the class
   */
  TAG: string = "UploadSimpleFileComponent";
  title: string = "Add DTM to the site";
  titlesub: string = "";
  public dialogRef: MatDialogRef<any>;

  hasBaseDropZoneOver: boolean = false;
  geojson: any = "";
  layerName: string = "";
  layerId: string = "";
  layerNameEditable: boolean = true;
  myform: FormGroup;
  alertmessage: MessageError | string;
  acceptFilter="";//".geojson ,text/plain";
  fileMessagePlaceholder:string="Choose file to upload";
  hint:string="";
  upload_type:any={};
  serviceCallback:any;
  target_data:any;
  handleResultMessage:string="Your file was uploaded.";
  formData:any=[];

  constructor(
    private uploadService: UploadService,
    private fb:FormBuilder,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    super();

      if (data.title) {
        this.title = data.title;
      }
      
      if (data.titlesub) {
        this.titlesub = data.titlesub;
      }
      if (data.fileMessagePlaceholder) {
        this.fileMessagePlaceholder = data.fileMessagePlaceholder;
      }      
      if (data.acceptFilter) {
        this.acceptFilter = data.acceptFilter;
      }
      if (data.hint) {
        this.hint = data.hint;
      }
      if (data.upload_type) {
        this.upload_type = data.upload_type;
      }   
      if (data.target_data) {
        this.target_data = data.target_data;
      }         
      if (data.serviceCallback) {
        this.serviceCallback = data.serviceCallback;
      }      
      if (data.handleResultMessage) {
        this.handleResultMessage = data.handleResultMessage;
      }
      if (data.formData) {
        this.formData = data.formData;
      }   
      else{
        this.formData=[];
      }   
      
    
    this.createForm();
    this.loadinglist=false;
  }

  ngOnInit() {
  }
  showerror(message: string, err?: any) {
    this.alertmessage = ErrorcontrolService.basichandleError(message, err, null, this.TAG);
  }

  isvalid() {
    if (this.fileSelected == null) {
      return false;
    }
    if (this.submitted){
      return false;
    }
    return true;
  }

  okaction() {
    if (this.fileSelected == null) {
      this.showerror("Please select a valid file.")
      return;
    }
    const formModel = this.myform.value;
    let res: any;
    this.uploadFile();
  }

  public static openModal(dialog: MatDialog, dialogData?: any): MatDialogRef<UploadSimpleFileComponent> {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "700px";
    dialogConfig.data = dialogData;

    let dialogRef: MatDialogRef<UploadSimpleFileComponent>;
    dialogRef = dialog.open(UploadSimpleFileComponent, dialogConfig);
    return dialogRef;
  }

  createForm() {
    this.myform = this.fb.group({

    });

  }
  fileMessage: string = "Choose file with GeoData";
  fileSelected:any;
  fileSelectedEventHandler($event) {
    try {
      //console.log("fileChangeEvent", event);
      let files = $event;//.target.files;
      let msg: string = "";
      for (let f of files) {
        msg += f.name;
        console.log("File selected", f);
        this.fileSelected=f;        
        break;//only one
      }
      this.fileMessage = msg;
    }
    catch (err) {
      this.showerror("Error ocurred with file selected. ", err);
    }

  }


  handleFileLoad(event) {
    //this.fileContents = event.target.result;
  }

  private uploadFile() {
    //save to server    
    this.submitted = true;
    this.loading = true;
    this.alertmessage = null;
    try {
      const formData = new FormData();
      formData.append("file", this.fileSelected);
      for (let entry of this.formData){
        formData.append(entry[0], entry[1]);
      }
     
      
      this.serviceCallback(this.target_data, formData)
        .subscribe((res) => this.handleresult(res), err => this.savehandleError(err)
        );

    } catch (error) {
      this.submitted = false;
      this.loading = false;
      this.showerror(error);
      console.log(error);
    }
  }

  private handleresult(resultmodel: any) {
    this.submitted = false;
    this.loading = false;  
    this.showmessage(this.handleResultMessage);
    //TODO: ok, se ha guardado, que hacemos con la capa, la borramos y el sistema mostrará la capa?

  }

  private savehandleError<T>(err: any) {
    this.submitted = false;
    this.loading = false;
    this.handleError(err);
  }

}
